<template>
  <div class="main">
    <c-panel title="Execução" titleIcon="fas fa-clipboard-check">
      <form-execucao :paramId="id" @onSubmitExecucao="afterSubmit"></form-execucao>
    </c-panel>
  </div>
</template>

<script>
import formExecucao from "./form"

export default {
  components: { formExecucao },
  computed: {
    id () { return this.$route.params.id }
  },
  methods: {
    afterSubmit () { this.$router.push('/admin/transporte/execucao') }
  }
}
</script>

